import { render } from "./LabResults.vue?vue&type=template&id=87ef681c&scoped=true"
import script from "./LabResults.vue?vue&type=script&lang=js"
export * from "./LabResults.vue?vue&type=script&lang=js"

import "./LabResults.vue?vue&type=style&index=0&id=87ef681c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ef681c"]])

export default __exports__